module.exports = __webpack_public_path__ + "static/stardust-card-basic-e725a0c75d02431a201fd16c6f994d2d.png";